import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function DefaultRenderer({ document, file }: Props) {
  return (
    <object
      className={styles.renderer}
      data={file.uri}
      type={document.mimeType}
    />
  );
}

export { DefaultRenderer };
